/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSitemap} from '@fortawesome/pro-duotone-svg-icons';

const GrantAwardApprovalIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faSitemap} {...props} />
);

export default GrantAwardApprovalIcon;
